import { faCameraRetro, faCaretRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { CompletionRequirementContent } from "./CompletionRequirementContent"
import { useCompletionRequirementModalStore } from "./CompletionRequirementModal"
import AnimatedStars from "../../../../components/animatedStars/AnimatedStars"
import useMobile from "../../../../hooks/useMobile"
import { useAddEditQuestStore } from "../useAddEditQuestStore"

export const CompletionRequirementSection = () => {
  const { reqReview, reqPhoto, reqNotes, maxAutoVerifyCount, selectedQuest } =
    useAddEditQuestStore()
  const { onOpen: onOpenCompletionRequirementModal } =
    useCompletionRequirementModalStore()
  const [isExpanded, setIsExpanded] = useState(false)
  const { t } = useTranslation()

  const isMobile = useMobile()
  const isEditing = !!selectedQuest
  const isAutoVerifyEnabled = maxAutoVerifyCount !== null

  const manualReviewText =
    reqPhoto && reqNotes
      ? t("QUEST_MANUAL_REVIEW_PHOTO_NOTES")
      : reqPhoto
        ? t("QUEST_MANUAL_REVIEW_PHOTO")
        : reqNotes
          ? t("QUEST_MANUAL_REVIEW_NOTES")
          : t("QUEST_MANUAL_REVIEW")

  const handleExpand = () => {
    if (isMobile) {
      onOpenCompletionRequirementModal()
    } else {
      setIsExpanded(!isExpanded)
    }
  }

  return (
    <div className="flex flex-col w-full">
      <button onClick={handleExpand} className="w-full">
        <div
          className={`flex flex-row gap-2 items-center p-3 px-4 w-full border-b border-borderPrimary ${isAutoVerifyEnabled ? "bg-gradient-to-r from-white from-30% to-pink-100" : ""}`}
        >
          {!isMobile && (
            <FontAwesomeIcon
              icon={faCaretRight}
              size="lg"
              className={`transition-transform duration-100 ${isExpanded ? "rotate-90" : ""}`}
              color={JoonUIColor.icon.neutral}
            />
          )}
          {isAutoVerifyEnabled ? (
            <div className="flex flex-row items-center w-full gap-1">
              <div className="translate-x-[-2px]">
                <AnimatedStars animate={false} scale={0.7} />
              </div>
              <Typography variant="bodySmallBold">
                {t("QUEST_AUTO_REVIEW_AI")}
              </Typography>
            </div>
          ) : (
            <div className="flex flex-row items-center w-full gap-2">
              <FontAwesomeIcon
                icon={faCameraRetro}
                size="sm"
                color={
                  reqReview ? JoonUIColor.icon.accent : JoonUIColor.icon.neutral
                }
              />
              <div className="flex flex-row gap-2 justify-between w-full">
                <Typography variant="bodySmallBold">
                  {reqReview ? manualReviewText : t("QUEST_ADD_COMPLETION_REQ")}
                </Typography>
                {!isEditing && !reqNotes && !reqPhoto && (
                  <div className="flex flex-row gap-2 items-center">
                    <AnimatedStars animate={false} scale={0.7} />
                    <Typography
                      variant="bodySmall"
                      color={JoonUIColor.text.primaryAccent}
                    >
                      {t("QUEST_ADD_AI_REVIEW")}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </button>
      {isExpanded && (
        <div className="flex flex-col gap-2 py-3 px-4">
          <CompletionRequirementContent />
        </div>
      )}
    </div>
  )
}
